import React, { useState, useEffect } from "react";
import SideBar from "../Components/SideBar.js";
import "./all_doctors.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config.js";
export default function AllDoctors() {
  const [search, setSearch] = useState("");
  const [doctors, setDoctors] = useState([]);

  // فتح وإغلاق قائمة الفلترة
  const [showFilters, setShowFilters] = useState(false);

  // خيارات الفلترة
  const [sortOrder, setSortOrder] = useState("newest");
  const [selectedSpecialization, setSelectedSpecialization] = useState("");
  const [selectedHospital, setSelectedHospital] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const navigate = useNavigate();

 useEffect(() => {
    const fetchDoctorsData = async () => {
      const token = localStorage.getItem("access_token");
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      try {
        // جلب الأطباء والمستخدمين والمستشفيات معاً في نفس الوقت
        const [doctorsRes, usersRes, hospitalsRes] = await Promise.all([
          fetch(`${API_BASE_URL}/doctors/`, { headers }),
          fetch(`${API_BASE_URL}/users/`, { headers }),
          fetch(`${API_BASE_URL}/hospitals/`, { headers })
        ]);

        const doctorsData = await doctorsRes.json();
        const usersData = await usersRes.json();
        const hospitalsData = await hospitalsRes.json();

        const docsArray = Array.isArray(doctorsData) ? doctorsData : (doctorsData.results || []);
        const usersArray = Array.isArray(usersData) ? usersData : (usersData.results || []);
        const hospsArray = Array.isArray(hospitalsData) ? hospitalsData : (hospitalsData.results || []);

        // دمج البيانات بناءً على المعرف (ID)
        const mergedDoctors = docsArray.map(doc => {
          const userObj = usersArray.find(u => u.id === doc.user) || {};
          const hospObj = hospsArray.find(h => h.id === doc.hospital) || {};

          return {
            ...doc,
            user_id: userObj.id || doc.user,
            real_name: userObj.real_name || "",
            phon_number: userObj.phon_number || "",
            admin_approved: userObj.admin_approved || false, // حالة الحساب من API المستخدمين
            hospital_name: hospObj.name || ""
          };
        });

        setDoctors(mergedDoctors);
      } catch (err) {
        console.error("Fetch error:", err);
        setDoctors([]);
      }
    };

    fetchDoctorsData();
  }, []);
  // استخراج التخصصات الموجودة فعلياً
  const specializations = [
    ...new Set(
      doctors
        .map((doctor) => doctor.specialization)
        .filter(Boolean)
    ),
  ];

  // استخراج المشافي الموجودة فعلياً
  const hospitals = [
    ...new Set(
      doctors
        .map((doctor) => doctor.hospital_name)
        .filter(Boolean)
    ),
  ];

  // تطبيق البحث والفلترة والترتيب
  const filteredDoctors = [...doctors]
    .filter((doctor) => {
      const value = search.toLowerCase().trim();

      const matchesSearch =
        doctor.real_name?.toLowerCase().includes(value) ||
        doctor.specialization?.toLowerCase().includes(value) ||
        doctor.phon_number?.includes(value);

      const matchesSpecialization =
        selectedSpecialization === "" ||
        doctor.specialization === selectedSpecialization;

      const matchesHospital =
        selectedHospital === "" ||
        doctor.hospital_name === selectedHospital;
      
      const isApproved = doctor.admin_approved ?? doctor.user?.admin_approved ?? false;
      const matchesStatus = 
        selectedStatus === "" || 
        (selectedStatus === "active" && isApproved) || 
        (selectedStatus === "pending" && !isApproved);
      
      return (
        matchesSearch &&
        matchesSpecialization &&
        matchesHospital &&
        matchesStatus
      );
    })
    .sort((a, b) => {
      if (sortOrder === "newest") {
        return b.id - a.id;
      }

      if (sortOrder === "oldest") {
        return a.id - b.id;
      }

      return 0;
    });

  // إعادة الفلاتر للوضع الافتراضي
  const resetFilters = () => {
    setSortOrder("newest");
    setSelectedSpecialization("");
    setSelectedHospital("");
  };

  return (
    <div className="all-doctors-container" dir="rtl">

      {/* SIDEBAR */}
      <div className="all-doctors-right">
        <SideBar role="admin" />
      </div>

      <main className="all-doctors-left">

        <div className="all-doctors-bg-watermark"></div>

        {/* HEADER */}
        <div className="all-doctors-header">
          <h1 className="all-doctors-title">
            <span
              onClick={() => navigate("/accounts-manager")}
              className="all-doctors-link"
            >
              مدير الحسابات
            </span>

            {" / "}

            <span className="all-doctors-link active">
              الأطباء
            </span>
          </h1>
        </div>

        {/* SEARCH + FILTER */}
        <div className="all-doctors-search-row">

          {/* SEARCH */}
          <div className="all-doctors-search-container">

            <input
              type="text"
              className="all-doctors-search-input"
              placeholder="ابحث عن اسم الطبيب أو تخصصه أو رقمه الشخصي ..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <i className="fa-solid fa-magnifying-glass all-doctors-search-icon"></i>

          </div>
          
          
          {/* FILTER BUTTON */}
          <button
            className={`all-doctors-filter-btn ${
              showFilters ? "active" : ""
            }`}
            onClick={() => setShowFilters(!showFilters)}
            title="فلترة الأطباء"
          >
            <i className="fa-solid fa-filter"></i>
          </button>

          {/* ADD DOCTOR BUTTON (تم نقله إلى هنا) */}
          <button
            className="all-doctors-add-btn"
            onClick={() => navigate("/create-doctor")}
            title="إضافة طبيب"
          >
            <i className="fa-solid fa-plus"></i>
          </button>


        </div>


        {/* FILTER PANEL */}
        {showFilters && (
          <div className="all-doctors-filter-panel">

            <div className="all-doctors-filter-group">
              <label><i className="fa-solid fa-user-check"></i> حالة الحساب</label>
              <select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                <option value="">الكل</option>
                <option value="active">مفعل</option>
                <option value="pending">قيد الانتظار</option>
              </select>
            </div>

            {/* SORT */}
            <div className="all-doctors-filter-group">

              <label>
                <i className="fa-solid fa-arrow-down-wide-short"></i>
                ترتيب الأطباء
              </label>

              <select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <option value="newest">
                  الأحدث أولاً
                </option>

                <option value="oldest">
                  الأقدم أولاً
                </option>
              </select>

            </div>


            {/* SPECIALIZATION */}
            <div className="all-doctors-filter-group">

              <label>
                <i className="fa-solid fa-stethoscope"></i>
                التخصص
              </label>

              <select
                value={selectedSpecialization}
                onChange={(e) =>
                  setSelectedSpecialization(e.target.value)
                }
              >

                <option value="">
                  كل التخصصات
                </option>

                {specializations.map((specialization, index) => (
                  <option
                    key={index}
                    value={specialization}
                  >
                    {specialization}
                  </option>
                ))}

              </select>

            </div>


            {/* HOSPITAL */}
            <div className="all-doctors-filter-group">

              <label>
                <i className="fa-solid fa-hospital"></i>
                المشفى
              </label>

              <select
                value={selectedHospital}
                onChange={(e) =>
                  setSelectedHospital(e.target.value)
                }
              >

                <option value="">
                  كل المشافي
                </option>

                {hospitals.map((hospital, index) => (
                  <option
                    key={index}
                    value={hospital}
                  >
                    {hospital}
                  </option>
                ))}

              </select>

            </div>


            {/* RESET */}
            <button
              className="all-doctors-reset-filter"
              onClick={resetFilters}
            >
              <i className="fa-solid fa-rotate-left"></i>
              إعادة ضبط الفلاتر
            </button>

          </div>
        )}


        {/* LIST */}
        <div className="all-doctors-list">

          {filteredDoctors.length > 0 ? (

            filteredDoctors.map((doctor) => (

              <div
                key={doctor.id}
                className="all-doctors-card"
                onClick={() =>
                navigate(`/doctor/${doctor.id}`, {
                state: { role: "admin" }
                })
                }
                >

                <div className="all-doctors-icon">
                  <i className="fa-solid fa-user-doctor"></i>
                </div>


                <div className="all-doctors-info">

                  <h3 className="all-doctors-name">
                    الاسم: {doctor.real_name}
                  </h3>

                  <div className="all-doctors-details">

                    <p className="all-doctors-code">
                      التخصص: {doctor.specialization}
                    </p>

                    <p className="all-doctors-code">
                      رقم الهاتف: {doctor.phon_number}
                    </p>

                    <p className="all-doctors-code">
                      المشفى: {doctor.hospital_name}
                    </p>

                  </div>

                </div>

              </div>

            ))

          ) : (

            <div className="all-doctors-no-results">
              <i className="fa-solid fa-user-doctor"></i>

              <p>
                لا يوجد أطباء مطابقون للبحث أو الفلاتر المحددة
              </p>
            </div>

          )}


         
        </div>

      </main>
    </div>
  );
}